import React, { useMemo } from 'react';

import { useParams } from 'react-router-dom';

import useHashmapConverter from 'hooks/useHashmapConverter';
import { useLogicCheckerFilterHook } from 'hooks/useLogicCheckerFilterHook';

import { useValidationStore } from 'store/validation.store';

import { useQueryGetLogicCheckerCategoryResults } from 'api/queries/getLogicCheckerCategoryResults.query';
import { useQueryGetValidationTypeDrillDown } from 'api/queries/getValidationTypeDrillDown.query';

import { WholeProjectRowComponent } from 'components/widgets/WholeProjectRow/components/WholeProjectRowComponent';

import { getCheck, isWholeProject } from 'utilitys/logicQualityCheck.utils';

export const WholeProjectRowWrapper = ({ columns, check }) => {
    const { validation: validationStore } = useValidationStore();

    const {
        id: versionId,
        category: categoryUrlParam,
        check: checkUrlParam,
    } = useParams<{ id: string; category: string; check: string }>();

    const { idList } = useHashmapConverter(versionId);
    const fileMetaDataId = idList.length > 0 ? parseInt(idList.join(',')) : undefined;

    //read global filters from store
    const filters = useLogicCheckerFilterHook();

    const { data: logicCheckerData } = useQueryGetLogicCheckerCategoryResults({
        fileMetaDataId,
        filter: {
            filters,
        },
    });
    const parsedCategory = categoryUrlParam.replace('_', '/');
    const parsedCheck = checkUrlParam ? checkUrlParam.replace('_', '/') : '';

    const pickedCheck = getCheck({
        categoriesSummaryRows: logicCheckerData?.categoriesSummaryRows,
        parsedCategory,
        parsedCheck,
    });

    const { data: validationTypeDrillDown } = useQueryGetValidationTypeDrillDown({
        fileMetaDataId,
        componentId: pickedCheck?.validationId,
        filter: {
            filters,
        },
    });

    const wholeProjectRow = useMemo(() => {
        if (validationTypeDrillDown) {
            const row = validationTypeDrillDown?.rows?.at(-1);
            return row && !isWholeProject(row) ? row : undefined;
        }
    }, [validationTypeDrillDown]);

    return wholeProjectRow ? (
        <WholeProjectRowComponent
            row={wholeProjectRow as unknown}
            validation={validationStore}
            columns={columns}
            check={check}
        />
    ) : null;
};
